export const shouldShowSurveyForTicket = (ticketData) => {
  if (!ticketData) {
    return false;
  }

  return ticketData.closeStatus !== "CLOSED_BY_SYSTEM";
};
